import React from "react";
import { BsTrophyFill } from "react-icons/bs";
import { SiAntdesign } from "react-icons/si";
import { BiCodeAlt } from "react-icons/bi";
import FunFactCard from "./FunFactCard";

const FunFact = () => {
  return (
    <div className="px-0 grid grid-cols-2 md:grid-cols-4 pb-10">
      <FunFactCard icon={<BsTrophyFill />} des="12 Achivements Won" />
      <FunFactCard
        icon={<SiAntdesign />}
        des="99+ Finished Projects During Course"
      />
      <FunFactCard icon={<BiCodeAlt />} des="781+ hours of coding" />
    </div>
  );
};

export default FunFact;
